
<div class="builder">
  <div
    v-for="(rule, index) in rules"
    :key="index"
    class="rule-block"
  >

    <template v-for="(_, index) in rule.conditions.length">
      <PatternBuilder
        :rule.sync="rule.conditions[index]"
        :join.sync="rule.joins[index]"
        :conditions.sync="rule.conditions"
        :noLabels="(index) > 0"
      />

      <!-- <pre><code>
        {{ JSON.stringify({
          index,
          existJoin: rule.joins[index],
        }, null, 2) }}
      </code></pre> -->

      <JoinSelector
        v-if="rule.joins[index]?.operator"
        :join.sync="rule.joins[index]"
        :key="index"
      />

    </template>

  </div>

  <pre><code>
  {{ JSON.stringify(rules, null, 2) }}
</code></pre>
</div>
